import React, { useEffect, useRef, useState } from "react";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import { SidebarData } from "./SidebarData";
import "./Navbar.css";
import Logo from "../assets/logo1.png";

const Nav = ({ sidebar, toggleSidebar }) => {
  const sidebarRef = useRef(null);

  // Currently opened menu
  const [openMenu, setOpenMenu] = useState(null);

  // Open / Close parent menu
  const handleMenuClick = (index) => {
    setOpenMenu((prev) => (prev === index ? null : index));
  };

  // Close sidebar when child clicked
  const handleLinkClick = () => {
    toggleSidebar();
  };

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        toggleSidebar();
      }
    };

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        toggleSidebar();
      }
    };

    if (sidebar) {
      document.addEventListener(
        "mousedown",
        handleClickOutside
      );

      window.addEventListener(
        "keydown",
        handleEsc
      );
    }

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );

      window.removeEventListener(
        "keydown",
        handleEsc
      );
    };
  }, [sidebar, toggleSidebar]);

  return (
    <nav
      className={sidebar ? "nav-menu active" : "nav-menu"}
      ref={sidebarRef}
    >
      {/* Header */}
      <div className="d-flex align-items-center justify-content-between mb-3 mx-3 mt-2">
        <img
          src={Logo}
          alt="EBS Transliteration"
          className="sidebar-logo img-fluid"
        />

        <Link
          id="menu-bar-close-x-toggle"
          to="#"
          className="menu-bars close-toggle"
          onClick={toggleSidebar}
        >
          <AiIcons.AiOutlineClose size={30} />
        </Link>
      </div>

      {/* Sidebar Menu */}
      <ul className="nav-menu-items list-unstyled px-2">

        {SidebarData.map((section, index) => (
          <li key={index} className="mb-2">
            {/* Parent */}
            <button
              id={`${section.title.toLowerCase().replace(/\s+/g, "-")}-title-${index}`}
              type="button"
              className="btn btn-dark w-100 d-flex justify-content-between align-items-center py-2"
              onClick={() => handleMenuClick(index)}
            >
              <span className="d-flex align-items-center">
                {section.icon}

                <span className="ms-2 fs-5">
                  {section.title}
                </span>
              </span>

              {/* Arrow */}
              <AiIcons.AiOutlineDown
                size={18}
                className={`menu-arrow ${openMenu === index ? "rotate" : ""
                  }`}
              />
            </button>

            {/* Children */}
            <div
              className={`collapse ${openMenu === index ? "show" : ""
                }`}
            >
              <ul className="list-unstyled mt-2">
                {section.children.map((item, childIndex) => (
                  <li key={childIndex} className="mb-1">
                    <Link
                      id={`section-${section.title.toLowerCase().replace(/\s+/g, "-")}-child-${childIndex}`}
                      to={item.path}
                      onClick={handleLinkClick}
                      className="nav-link menu-child text-light rounded px-3 py-2 ms-3 d-flex align-items-center"
                    >
                      {item.icon}

                      <span className="ms-2">
                        {item.title}
                      </span>
                    </Link>

                  </li>

                ))}

              </ul>
            </div>

          </li>

        ))}

      </ul>
    </nav>
  );
};

export default Nav;